export const MARGIN_HORIZONTAL = 104;
export const MOBILE_MARGIN_HORIZONTAL = 16;
